// extracted by mini-css-extract-plugin
module.exports = {"container":"cTZnej","details":"_1BHqSl","message":"AF2BX8"};